import React from "react";
import { BaseContainerProps } from "./definitions";

export const BaseContainer = ({ children, className }: BaseContainerProps) => {
  return <div className={`h-screen ${className}`}>{children}</div>;
};
